import { Plan } from "@features/plans";
import { useMutation, useQuery, useQueryClient } from "react-query";

const UPGRADE_NEEDED_MODAL_QUERY_KEY = "upgrade-needed-modal";

export const useUpgradeNeededModal = () => {
  const queryClient = useQueryClient();

  // Get the current state
  const currentState = useQuery(
    [UPGRADE_NEEDED_MODAL_QUERY_KEY],
    () => {
      return { isOpen: false, minimumPlan: undefined, minimumCredits: 0 };
    },
    { enabled: false }
  );

  // Mutation to open the modal
  const openModal = useMutation({
    mutationFn: (args: { minimumPlan?: Plan; minimumCredits?: number }) => {
      return Promise.resolve();
    },
    onMutate: ({
      minimumPlan,
      minimumCredits,
    }: {
      minimumPlan?: Plan;
      minimumCredits?: number;
    }) => {
      queryClient.setQueryData([UPGRADE_NEEDED_MODAL_QUERY_KEY], {
        isOpen: true,
        minimumPlan,
        minimumCredits,
      });
    },
  });

  // Mutation to close the modal
  const closeModal = useMutation({
    mutationFn: () => {
      return Promise.resolve();
    },
    onMutate: () => {
      queryClient.setQueryData([UPGRADE_NEEDED_MODAL_QUERY_KEY], {
        isOpen: false,
      });
    },
  });

  return {
    isOpen: !!currentState.data?.isOpen,
    minimumPlan: currentState.data?.minimumPlan || "basic",
    minimumCredits: currentState.data?.minimumCredits || 0,
    openModal: (args: { minimumPlan?: Plan; minimumCredits?: number }) =>
      openModal.mutate(args),
    closeModal: () => closeModal.mutate(),
  };
};
